import React from 'react';

import { faCheckCircle } from '@fortawesome/pro-regular-svg-icons';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';

import { supportReply } from '../../../slices/LeoSlice';
import { AppDispatch } from '../../../types';
import { cn } from '../../../utils/classUtils';
import { UserIntentEnum } from '../../../utils/LeoUtils';
import Button from '../../Button';
import NeoLeoShareFilesDnD from './NeoLeoShareFilesDnD';

interface NeoLeoCreateSupportTicketMsgV2Props {
  session_id: string;
}

enum ActionEnum {
  CREATE_SUPPORT_TICKET = 'CREATE_SUPPORT_TICKET',
  NO_ACTION = 'NO_ACTION',
}

const NeoLeoCreateSupportTicketMsgV2: React.FC<
  NeoLeoCreateSupportTicketMsgV2Props
> = ({ session_id }) => {
  const dispatch = useDispatch<AppDispatch>();
  const [actionTaken, setActionTaken] = React.useState<ActionEnum>();
  const choseCreateTicket = actionTaken === ActionEnum.CREATE_SUPPORT_TICKET;
  const isNoAction = actionTaken === ActionEnum.NO_ACTION;

  const handleCreateTicket = async () => {
    setActionTaken(ActionEnum.CREATE_SUPPORT_TICKET);
  };

  const stopCreateSupportTicket = async () => {
    setActionTaken(ActionEnum.NO_ACTION);
    await dispatch(supportReply(UserIntentEnum.SUPPORT_DISMISSED, session_id));
  };

  if (choseCreateTicket) {
    return (
      <div>
        <NeoLeoShareFilesDnD session_id={session_id} />
      </div>
    );
  }

  return (
    <div>
      <p className='mb-2'>
        Please confirm if you would like to create a support ticket.
      </p>
      <div className='flex-col space-y-2 items-center justify-center'>
        {(!actionTaken || choseCreateTicket) && (
          <Button
            leftIcon={
              <FontAwesomeIcon
                icon={choseCreateTicket ? faCheckCircle : faPlus}
                className={cn(
                  choseCreateTicket ? 'text-reskin-regent-600' : 'text-white',
                )}
                size='sm'
              />
            }
            onPress={handleCreateTicket}
            isDisabled={choseCreateTicket}
            variant='primary-outline'
            fullWidth
            label={
              choseCreateTicket
                ? 'Support Ticket Inititated'
                : 'Create Support Ticket'
            }
          />
        )}
        {(!actionTaken || isNoAction) && (
          <Button
            leftIcon={
              <FontAwesomeIcon
                icon={faCheckCircle}
                className='text-reskin-regent-600'
                size='sm'
              />
            }
            onPress={stopCreateSupportTicket}
            isDisabled={isNoAction}
            variant='primary-outline'
            fullWidth
            label="No, I'm good"
          />
        )}
      </div>
    </div>
  );
};

export default NeoLeoCreateSupportTicketMsgV2;
